const utm = (medium: string) =>
  `utm_source=landing_page&utm_medium=${medium}&utm_campaign=download`;

export const APP_STORE_URL = `https://apps.apple.com/us/app/morph-inspect/id6737966284?utm_source=qr_code&utm_medium=landing_page&utm_campaign=download`;

export const GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=com.morph_technologies.inspectionapp&utm_source=qr_code&utm_medium=landing_page&utm_campaign=download`;

export const WEB_DOWNLOAD_URL = `https://www.morph-technologies.com/#download?utm_source=qr_code&utm_medium=landing_page&utm_campaign=download`;

export const APP_STORE_URL_BADGE = `https://apps.apple.com/us/app/morph-inspect/id6737966284?${utm('badge')}`;
export const GOOGLE_PLAY_URL_BADGE = `https://play.google.com/store/apps/details?id=com.morph_technologies.inspectionapp&${utm('badge')}`;

export const BOOK_A_DEMO_URL =
  'mailto:info@morph-technologies.com?subject=Book%20a%20Morph%20demo';

export const WEB_APP_URL =
  process.env.REACT_APP_WEB_APP_URL || 'https://app.morph-technologies.com';
